import { render, staticRenderFns } from "./AirMenu.vue?vue&type=template&id=1877946c&scoped=true"
import script from "./AirMenu.vue?vue&type=script&lang=js"
export * from "./AirMenu.vue?vue&type=script&lang=js"
import style0 from "./AirMenu.vue?vue&type=style&index=0&id=1877946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877946c",
  null
  
)

export default component.exports